import React from 'react';
import { useTranslation } from 'react-i18next';
import apeswapLogo from '../../assets/imgs/logo-apeswap.png';
// import bitmartLogo from '../../assets/imgs/logo-bitmart.png';
import kucoinLogo from '../../assets/imgs/logo-kucoin.png';
import mxcLogo from '../../assets/imgs/logo-mxc.png';
import quickswapLogo from '../../assets/imgs/logo-quickswap.png';
import sushiLogo from '../../assets/imgs/logo-sushiswap.png';
import uniswapLogo from '../../assets/imgs/logo-uniswap.png';
import { HomeSectionTitle } from '../HomeSectionTitle/HomeSectionTitle';
import styles from './WhereToGetTower.module.scss';
import PolygonLogo from '../../assets/icons/icon-polygon-circle.png';
import EthereumLogo from '../../assets/icons/icon-ethereum-circle.png';
import BinanceLogo from '../../assets/icons/icon-binance-square.png';

const quickswapTowerUrl = 'https://quickswap.exchange/#/analytics/v2/pair/0xc74e7a5cdbf0c916d5bffa7b6bddd43ab46e72ea'
const uniswapTowerUrl = 'https://info.uniswap.org/#/pools/0x74c6eb5e3f55b372a0147c2438f4e7c07a965f9f';
const kucoinTowerUrl = 'https://www.kucoin.com/trade/TOWER-USDT';
const mxcTowerUrl = 'https://www.mexc.com/exchange/TOWER_USDT';
// const bilaxyTowerUrl = 'https://bilaxy.com/trade/TOWER_ETH';
const sushiswapUrl = 'https://www.sushi.com/earn/eth:0xdbaa04796cb5c05d02b8a41b702d9b67c13c9fa9';
// const bitmartUrl = 'https://www.bitmart.com/trade/en?layout=basic&symbol=TOWER_USDT';
const apeswapUrl = 'https://info.apeswap.finance/pair/0x1b332e08f0957d43ff8c2760bf49af8d3798959d';

export const TowerAvailableOn = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.available_logos_section} id="available_on">
            <div className={styles.section_title}>
                <HomeSectionTitle title={t('TOWER_ALSO_AVAILABLE')} />
            </div>

            <div className={styles.available_on_liquidity_text}>TOWER is available on the following liquidity pools. You can get TOWER from the below chains:</div>

            <div className={styles.available_body}>
                <div className={styles.network_links_container}>
                    <div className={`${styles.network_title_container} ${styles.polygon}`}>
                        <img src={PolygonLogo} alt="polygon" />
                        <div>Polygon Chain</div>
                    </div>
                    <div className={styles.network_links_body}>
                        <div className={styles.link}>
                            <a href={quickswapTowerUrl} target="_blank" rel="noopener noreferrer">
                                <img src={quickswapLogo} alt="quickswap" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className={styles.network_links_container}>
                    <div className={`${styles.network_title_container} ${styles.ethereum}`}>
                        <img src={EthereumLogo} alt="ethereum" />
                        <div>Ethereum Chain</div>
                    </div>
                    <div className={styles.network_links_body}>
                        <div className={styles.link}>
                            <a href={sushiswapUrl} target="_blank" rel="noopener noreferrer">
                                <img src={sushiLogo} alt="sushiswap" />
                            </a>
                        </div>
                        <div className={styles.link}>
                            <a href={kucoinTowerUrl} target="_blank" rel="noopener noreferrer">
                                <img src={kucoinLogo} alt="kucoin" />
                            </a>
                        </div>
                        <div className={styles.link}>
                            <a href={mxcTowerUrl} target="_blank" rel="noopener noreferrer">
                                <img src={mxcLogo} alt="mexc" />
                            </a>
                        </div>
                        <div className={styles.link}>
                            <a href={uniswapTowerUrl} target="_blank" rel="noopener noreferrer">
                                <img src={uniswapLogo} alt="uniswap" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className={styles.network_links_container}>
                    <div className={`${styles.network_title_container} ${styles.binance}`}>
                        <img src={BinanceLogo} alt="binance" />
                        <div>Binance Chain</div>
                    </div>
                    <div className={styles.network_links_body}>
                        <div className={styles.link}>
                            <a href={apeswapUrl} target="_blank" rel="noopener noreferrer">
                                <img src={apeswapLogo} alt="apeswap" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
